import {
  IUploadData,
  IUploadAdditional
} from '@/features/upload/store'
import {
  VND_EXCEL_MIME_TYPE,
  MIME_TYPES_EXCEL,
  MIME_TYPES_CSV,
  CSV_EXTENSION
} from '@/constants'

interface IPrepareForm {
  sheets?: any,
  sheetName?: string,
  dateFormat?: string,
  delimiterFormat?: string,
  keyPrefix: string,
  file: File,
  form: Array<IUploadAdditional>
}

export const getPrepareUploadData = (options: IUploadData) => {
  const { file, uploadData } = options
  const { name, type } = file
  const { url, fields, customerId, jobId, sheetName, dateFormat, delimiterFormat } = uploadData
  const form: Array<IUploadAdditional> = fields.map(({ name, value }: any) => ({ name, value }))
  const keyPrefix = `${customerId}/${jobId}`
  const extension = name.split('.').pop()

  const isExcel = isExcelFile(type, extension)
  const isCsv = isCsvFile(type, extension)
  let prepareForm

  if (isExcel) prepareForm = prepareExcelForm({ sheetName, keyPrefix, file, form, dateFormat })
  if (isCsv) prepareForm = prepareCsvForm({ url, keyPrefix, file, form, delimiterFormat })

  return {
    url,
    form: prepareForm
  }
}

const isExcelFile = (type: string, ext: string): boolean => {
  const isExcelMimeType = MIME_TYPES_EXCEL.includes(type)
  const isExcelExt = ext !== CSV_EXTENSION

  return isExcelMimeType && isExcelExt
}

const isCsvFile = (type: string, ext: string): boolean => {
  const isCsvMimeType = MIME_TYPES_CSV.includes(type)
  const isExcelCsv = VND_EXCEL_MIME_TYPE === type && ext === CSV_EXTENSION

  return isCsvMimeType || isExcelCsv
}

const prepareExcelForm = (options: IPrepareForm) => {
  const { sheetName, keyPrefix, file, form, dateFormat } = options

  form.push({ name: 'key', value: `${keyPrefix}/file.xlsx` })
  form.push({ name: 'Content-Type', value: file.type })
  form.push({ name: 'x-amz-meta-original-name', value: `${file.name}<sheetName>${sheetName}</sheetName>` })
  form.push({ name: 'x-amz-meta-date-format', value: dateFormat })
  form.push({ name: 'x-amz-meta-delimiter', value: ',' })
  form.push({ name: 'file', value: file })

  return form
}

const prepareCsvForm = (options: any) => {
  const { keyPrefix, file, form, delimiterFormat }: IPrepareForm = options

  form.push({ name: 'key', value: `${keyPrefix}/file.csv` })
  form.push({ name: 'Content-Type', value: 'text/csv' })
  form.push({ name: 'x-amz-meta-original-name', value: file.name })
  form.push({ name: 'x-amz-meta-date-format', value: '' })
  form.push({ name: 'x-amz-meta-delimiter', value: delimiterFormat })
  form.push({ name: 'file', value: file })

  return form
}
